import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.checkFormValid()
  }

  checkFormValid() {
    const form = this.element;
    const inputFields = Array.from(form.querySelectorAll('input:not([type="checkbox"]), select'));
    const checkboxes = Array.from(form.querySelectorAll('input[type="checkbox"]'));
    const submit = form.querySelector('input[type="submit"]');
    
    const allInputsFilled = inputFields.every(field => {
      if (field.tagName === 'SELECT') {
        return field.value !== ''
      }
      return field.value.trim() !== ''
    })

    const allCheckboxesChecked = checkboxes.length === 0 || checkboxes.every(checkbox => checkbox.checked)
    const isValid = allInputsFilled && allCheckboxesChecked
    
    submit.disabled = !isValid
  }
}
